import { GetBaseURL, MakeRequest } from '@/helpers/APIconnection';
export default {
  data: function () {
    return {
      MakeRequest
    };
  },
  computed: {
    APIconnected() {
      switch (new URL(GetBaseURL()).hostname) {
        case process.env.VUE_APP_HOST_API_DEV:
          return 'dev';
        case process.env.VUE_APP_HOST_API_PROD:
          return 'prod';
        default:
          return 'local';
      }
    }
  }
};